import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import { withFormik } from 'formik';
import DiscountForm from './DiscountForm';
import { addPromoCode } from 'src/client/js/store/thunks/cart';
import { getCartErrors } from 'src/client/js/store/selectors/cart';
import withCountry from '../../../hocs/withCountry';
import withGlobalContent from '../../../hocs/withGlobalContent';
import { trackGeneralClick } from '../../../../analytics/category/checkout';

const enhance = compose(
  withGlobalContent,
  withRouter,
  connect(
    state => ({
      cartErrors: getCartErrors(state),
    }),
    dispatch => ({
      addPromoCode: (code, resetForm) => dispatch(addPromoCode(code, resetForm))
    }),
  ),
  withCountry,
  withFormik({
    mapPropsToValues: () => ({ code: '' }),
    handleSubmit: (values, { props, ...action }) => {
      trackGeneralClick('Apply discount', props.history.location.pathname);
      props.addPromoCode(values.code, action.resetForm);
    }
  }),
  withHandlers({
    handleClick: (props) => () => {
      trackGeneralClick('into promo code field', props.history.location.pathname);
    },
  })
);

export default enhance(DiscountForm);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartSummary/DiscountForm/index.js